<template>
  <div
    class="brand-logo-slider-area section-space--inner--60"
    :class="addClass"
  >
    <div class="container">
      <div class="row text-left mb-5">
        <div class="col-lg-12">
          <h3 class="text-color-green font-size-24">
            <span class="span-hr-green-left"></span>KEWIRAUSAHAAN
          </h3>
          <!-- <p class="font-size-15">Testimoni dari SMA 1 Indonesia</p> -->
        </div>
      </div>
      <!-- brand logo slider -->
      <vue-horizontal class="horizontal" responsive>
        <section
          class="item"
          v-for="(item, index) in goodies"
          :key="`goodies_${index}`"
        >
          <div class="card">
            <router-link
              :to="`/kewirausahaan/detail-barang/${item.id}`"
              class="image"
              :style="{
                background: 'url(' + item.image + ')',
              }"
            ></router-link>

            <div class="content">
              <!-- name brand -->
              <router-link :to="`/kewirausahaan/detail-barang/${item.id}`">
                <div class="brand">
                  <div class="name">
                    {{
                      item.title.length > 50
                        ? item.title.slice(0, 50) + `...`
                        : item.title
                    }}
                  </div>
                </div>

                <div class="title">{{ item.description }}</div>
              </router-link>
              <!-- rating and count sold -->
              <div class="row">
                <div class="col-6 border-right">
                  <div class="rating d-flex aling-items-center">
                    <img
                      :src="
                        require('../../assets/images/kewirausahaan/rate.png')
                      "
                      alt=""
                    />
                    <p class="ml-2 rating-number">{{ item.rating }}</p>
                  </div>
                </div>
                <div class="col-6">
                  <div class="sold">Terjual {{ item.sold }}</div>
                </div>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col-12">
                  <div class=" border-bottom"></div>
                </div>
              </div>
              <!-- name store -->
              <div class="row d-flex align-items-center">
                <div class="col-3">
                  <div class="store-icon">
                    <img
                      class="img-fluid rounded-circle"
                      :src="item.merchant.logo"
                      alt=""
                    />
                  </div>
                </div>
                <div class="col-9">
                  <div class="name-store">
                    {{ item.merchant.name }}
                  </div>
                </div>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col-12">
                  <div class=" border-bottom"></div>
                </div>
              </div>
              <!-- price -->
              <div class="row">
                <div class="col-12">
                  <div class="price">Rp{{ formatNumber(item.price) }}</div>
                </div>
              </div>
              <!-- location -->
              <div class="row  d-flex align-items-center">
                <div class="col-2">
                  <div class="location">
                    <img
                      :src="
                        require('../../assets/images/kewirausahaan/location.png')
                      "
                      alt=""
                    />
                  </div>
                </div>
                <div class="col-10 pl-0">
                  <div class="name-location">
                    {{
                      item.merchant.location != null
                        ? item.merchant.location
                        : "Lokasi belum tersedia"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </vue-horizontal>

      <div class="row">
        <div class="col text-center">
          <router-link
            :to="`/kewirausahaan`"
            class="btn ht-btn-default--round mt-4 btn-primary-theme-green"
          >
            LIHAT SEMUA
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueHorizontal from "vue-horizontal";
import broker from "../../utils/broker";
import numeral from "numeral";

export default {
  props: ["data", "addClass"],
  data() {
    return {
      goodies: [],
      items: [1, 2, 3, 4, 5],
      title: "TOPI Capten GAMING motif Minecraft warna hijau tosca",
    };
  },
  mounted() {
    this.getDataGoodies();
  },
  methods: {
    getDataGoodies() {
      let self = this;
      broker.fetch
        .get(`/webschool/enterpreneur/goodies/summary`)
        .then((res) => {
          res.data.data.forEach((item) => {
            self.goodies.push(item);
          });
        });
    },

    formatNumber(value) {
      let formatted = numeral(value).format("0,0");
      return formatted;
    },
  },
  components: { VueHorizontal },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_kewirausahaan_template_2.scss";
</style>
<style>
.v-hl-btn-next.v-hl-btn-between {
  transform: translateX(100%) !important;
}
.v-hl-btn-prev.v-hl-btn-between {
  transform: translateX(-100%) !important;
}

.v-hl-svg {
  background: #01a24b !important;
  color: white !important;
  width: 30px !important;
  height: 30px !important;
}
</style>
